import { LoadingOrErrorContainer } from "@mallardbay/lib-react-components"
import React from "react"

import SelectControl from "~components/shared/hook-form/controls/select-control"
import useOutfitterListings from "~utils/use-outfitter-listings"
import COPY from "~config/copy-constants"

interface Props {
    readonly name: string
    readonly label?: string
    readonly isRequired?: boolean
    readonly outfitterId: string
}

export default function ListingSelectControl({
    name,
    label,
    isRequired,
    outfitterId,
}: Props) {
    const { options, isLoading, error } = useListingOptions(outfitterId)

    return (
        <LoadingOrErrorContainer
            isLoading={isLoading}
            error={error}
            shouldRenderChildren
            noPadding
        >
            <SelectControl
                name={name}
                label={label}
                options={options}
                placeholder={COPY.SELECT_A_LISTING}
                isRequired={isRequired}
            />
        </LoadingOrErrorContainer>
    )
}

function useListingOptions(outfitterId: string) {
    const { listings, isLoading, error } = useOutfitterListings({ outfitterId })
    const publishedListings = listings.filter((listing) => listing.published)

    const options = publishedListings.map((listing) => ({
        label: listing.title ?? "",
        value: listing.id,
    }))

    return { options, isLoading, error }
}
